// extracted by mini-css-extract-plugin
export default {"dimension":"JWZdo","name":"b1IOs","value":"jiMmJ","valueItem":"yOj27","vertical":"B1z0S","valueName":"kccSo","narrow":"hhOCe","valueValue":"vhcP0","delimiter":"Em4Y2"};